import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { UserRef } from '../../core/generated';
import { UserPreferencesCacheService } from './user-preferences-cache.service';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesCacheResolver implements Resolve<UserRef> {
  constructor(private cacheService: UserPreferencesCacheService) {}

  resolve(): Observable<UserRef> {
    return this.cacheService.getUser().pipe(take(1));
  }
}
